import withLinkCheck from "../hoc/withLinkCheck";

export default function CheckedLink({ children, link, navLink, classname }) {
	return withLinkCheck(children, link, navLink, classname);
}
